module.exports = __webpack_public_path__ + "img/upload-white.0f52be21.svg";